// redux/BillingInvoice/ThunkAction.ts

import { createAsyncThunk } from "@reduxjs/toolkit";
import { iBillingInvoiceRequest } from "./Types";
import { apiServer } from "@/services/api/cresivoxServer/axiosConfig";
import BillingInvoiceService from "@/services/api/cresivoxServer/addBillingService";


export const addBillingInvoice = createAsyncThunk(
  "billingInvoice/add",
  async (data: iBillingInvoiceRequest, { rejectWithValue }) => {
    try {
      const service = BillingInvoiceService(apiServer);
      const response = await service.addBillingDetails(data);

     //@ts-ignore
      if (response?.statusCode === 200) {
        return response?.data;
      } else {
        //@ts-ignore
        return rejectWithValue(response?.errorMessage || "Something went wrong");
      }
    } catch (error: any) {
      return rejectWithValue(error.message || "Network Error");
    }
  }
);
